import axios from 'axios';
import { getStorage, removeStorage } from './storage';
import { gptDomain, allBaseUrl, pptDomain } from '@/config/apiDomain';
import decrypt from './decrypt';
import { openLoginDialog } from '@/components/content/loginDialog/login';
import useStore from '@/stores/publicStore';
import { storeToRefs } from 'pinia';
import { isTest } from '@/data/pubilc';
import { addFetchEncrypt } from './index';

const http = axios.create({
  timeout: 60000
});

const getHttpType = (value: any) => {
  const data = value as { httpType: string | undefined };
  const result = data.httpType === undefined ? 'drawApi' : data.httpType;
  return result;
};

const addEkeyAndSoftId = (url: string) => {
  const unHaveParams = url.indexOf('?') === -1;
  if (unHaveParams) return url + `?ekey=${getStorage('ekey')}&soft_id=${getStorage('soft_id')}`;
  let addUrl = url;
  const unHaveEkeys = url.indexOf('ekey=') === -1;
  if (unHaveEkeys) addUrl += `&ekey=${getStorage('ekey')}`;
  const unHaveSoftId = url.indexOf('soft_id=') === -1;
  if (unHaveSoftId) addUrl += `&soft_id=${getStorage('soft_id')}`;
  return addUrl;
};

const getContentType = (value: any) => {
  const data = value as { ContentType: string | undefined };
  const result = data.ContentType || undefined;
  return result;
};

// request interceptor
http.interceptors.request.use(
  config => {
    config.url = addEkeyAndSoftId(config.url as string);
    const httpType = getHttpType(config);
    config.baseURL = allBaseUrl[httpType].url;
    if (config.baseURL?.includes(gptDomain) || config.baseURL?.includes(pptDomain)) {
      const params = {
        url: config.url,
        data: config.data,
        header: config.headers,
        needEncrypt: true
      };
      const res = addFetchEncrypt(params);
      config.url = res.url;
      config.data = res.data;
      config.headers = res.header;
    }
    if (getStorage('token')) {
      config.headers['Authorization'] = getStorage('token');
    }
    if (getContentType(config)) {
      config.headers['Content-Type'] = getContentType(config);
    }
    if (isTest.value) {
      config.headers['aTyE61q0WmqRnz9Y'] = 'BFR3vkiBY73GGeNm';
    }

    return config;
  },
  error => {
    return Promise.reject(error.message);
  }
);

const logout = () => {
  const publicStore = useStore();
  const { isLogin } = storeToRefs(publicStore);
  if (!isLogin.value) return;
  ElMessage.error('登录信息已过期，请重新登录');
  openLoginDialog();
  isLogin.value = false;
  removeStorage('token');
};

// response interceptor
http.interceptors.response.use(
  (response: any) => {
    const httpType = getHttpType(response.config.httpType);
    const isEncode = allBaseUrl[httpType].isEncode;
    const data = response.data;
    if (data) {
      let result = null;
      const data = response.data.data;
      result = data;
      if (isEncode && !isTest.value) {
        result = decrypt(data);
      }
      if (result.code === 403) {
        logout();
        return Promise.reject({
          unShow: true,
          msg: '请先登录'
        });
      }
      if (result.code > 300) {
        return Promise.reject(result);
      }
      return result;
    } else {
      return Promise.reject(response.error);
    }
  },
  error => {
    return Promise.reject({
      code: error.code,
      msg: error.message
    });
  }
);

export default http;
